import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ background: "#fff" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <h2>
              Our CRM <span>Development Services</span>
            </h2>
            <p>
              Our core competence lies in providing tailored CRM development
              services that revolutionize the sphere of customer relations. We
              provide consulting, development, deployment, and product support
              for CRM solutions more efficiently according to the needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Talk To Our Experts
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>CRM Consulting</h4>
                  <p>
                    Our CRM Consulting services aim to offer the best advisory
                    solutions for implementing efficient CRM systems. We audit
                    your existing CRM arrangements, evaluate drawbacks, and
                    compel the most advantageous strategies/technologies to meet
                    your company’s needs to optimize its performance.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Software Development </h4>
                  <p>
                    Our main focus is on creating boutique CRM software
                    solutions that respond to your business needs. Taking
                    advantage of existing intricate technologies and frameworks,
                    our approaches consist of reliable attributes like
                    automation, data analysis, and reporting tools to enhance
                    customers’ engagement and helpful decisions.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Deployment</h4>
                  <p>
                    CRM Deployment services are offered to guarantee that the
                    product developed reaches the user in the best shape. We
                    also assist in the setting up and customization of the CRM
                    system, teaching your workers how to use it and integrating
                    it into your enterprise’s functioning.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Mobile Solutions</h4>
                  <p>
                    Customer relations do not end when you are out of the
                    office; with the help of our CRM Mobile Solutions, they
                    continue. We build mobile applications for CRM that provide
                    its users with access to customer information and tools for
                    tasks and message handling from any location.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Integration</h4>
                  <p>
                    Our CRM Integration services help in linking your CRM with
                    other business applications like ERP, marketing automation,
                    and e-commerce. This guarantees coherence with the client's
                    view, which is especially important in an environment with
                    many representatives in the organization.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Migration</h4>
                  <p>
                    Our CRM Migration services entail the transfer of data from
                    one CRM system to a new and better one. Migration, setup,
                    and user training are done properly to reduce potential loss
                    of data while at the same time being very considerate of
                    users.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Software Customization </h4>
                  <p>
                    As for the CRM system, we provide the CRM Software
                    Customization to fit in your business processes and needs.
                    The customization services include workflows, dashboards,
                    modules, and plugins that would help in the perfect fitting
                    of the specific CRM solution with the organization’s
                    operations.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>CRM Software Maintenance</h4>
                  <p>
                    CRM Software Maintenance services are our services that
                    offer support and improvements to your CRM system
                    continuously. These services include system maintenance, bug
                    fixing, repairs, and technical support to keep the CRM
                    system optimally functional.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
